module.exports = "/_next/static/images/4c85249d13da6cc4c60419e939e08dfb-cajitas-left-mobile.jpg";